export default "__VITE_ASSET___x3rwi3L__"